module.exports = __webpack_public_path__ + "static/media/error_404.040114a7.svg";